/* eslint-disable @gorazdo/preact/prefer-classname */
import { FunctionalComponent } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { ModulesContext, publish } from '../../utils/globals'
import { ExternalPrivacyCookieConfig } from '../../services/generalConfig'

interface Props {
  rootUrl: string
  termsConditions: string
  cookieConfig: ExternalPrivacyCookieConfig
}

const PoweredByInsided: FunctionalComponent<Props> = (props: Props) => {
  return (
    <ModulesContext.Consumer>
      {modules => {
        const isCookieBannerEnabled = modules.includes('cookiebar') && !props.cookieConfig.use_external_modal
        const isRebrandDigitalHub = modules.includes('rebrandDigitalHub')
        const poweredByDescription = isRebrandDigitalHub ? 'Powered by Gainsight' : 'Powered by inSided'
        const externalLink = isRebrandDigitalHub ? 'https://info.gainsight.com/insided-referral.html' : `https://www.insided.com/powered-by-the-insided-platform?utm_medium=referral&utm_source=${props.rootUrl}&utm_content=powered-by-widget`
        const icon = isRebrandDigitalHub ? 'logo-gainsight' : 'logo-insided'
        const title = isRebrandDigitalHub ? 'Visit Gainsight.com' : 'Visit inSided.com'

        return (
          <div class='Template-footer'>
            <div class='sitewidth box box--blend' data-component='scrollTopStickyButton'>
              <div class='templatefoot'>
                <a href={externalLink} class={icon} title={title} target='_blank' rel='noreferrer'>
                  <span class='is-hidden'>{poweredByDescription}</span>
                </a>
              </div>
              <div class='templatefoot-privacy-links'>
                <a href={props.termsConditions}><Phrase p='Terms & Conditions' /></a>
                {isCookieBannerEnabled && <a onClick={() => publish('edit_cookie_settings', null)}><Phrase p='cookiepolicy.link' /></a>}
              </div>

              <Phrase p='branded.back_to_top'>
                {(phrase) => (
                  <span class='scroll-to-top-sticky-button js-scrollto widget--base-shadow is-hidden-S custom-scroll-to-top' title={phrase} />
                )}
              </Phrase>
            </div>
          </div>
        )
      }}
    </ModulesContext.Consumer>
  )
}

export default PoweredByInsided
